import { graphql } from "@cappelendamm/crystallize-types/catalogue/gql";
export const getProductByPath = async ({ path }, { client }) => {
    const data = await client.catalogue.request(graphql(`
      query ProductByPath($path: String!, $language: String) {
        catalogue(path: $path, language: $language) {
          ... on Product {
            __typename
            ...item
            ...product
            topics {
              path
              name
            }
          }
        }
      }

      fragment content on ComponentContent {
        ...boolean
        ...singleLine
        ...richText
        ...imageContent
        ...itemRelations
        ...dateTime
        ...numeric
      }

      fragment component on Component {
        id
        name
        type
        content {
          ...content
          ...contentChunk
        }
      }

      fragment dateTime on DatetimeContent {
        datetime
      }

      fragment imageContent on ImageContent {
        images {
          ...image
        }
      }

      fragment image on Image {
        url
        altText
        key
        variants {
          url
          width
          key
        }
      }

      fragment itemRelations on ItemRelationsContent {
        __typename
        items {
          id
          name
          path
        }
        productVariants {
          sku
          name
        }
      }

      fragment item on Item {
        id
        name
        type
        language
        path
        components {
          ...component
        }
      }

      fragment product on Product {
        variants {
          name
          sku
          attributes {
            attribute
            value
          }
          components {
            ...component
          }
          price
          priceVariants {
            identifier
            name
            price
            currency
          }
          isDefault
          images {
            url
            altText
            key
            variants {
              key
              width
              url
            }
          }
          subscriptionPlans {
            identifier
            name
            periods {
              id
              name
              initial {
                period
                unit
                priceVariants {
                  identifier
                  name
                  price
                  currency
                }
              }
              recurring {
                period
                unit
                priceVariants {
                  identifier
                  name
                  price
                  currency
                }
                meteredVariables {
                  id
                  name
                  identifier
                }
              }
            }
          }
        }
        vatType {
          name
          percent
        }
      }

      fragment richText on RichTextContent {
        json
        html
        plainText
      }

      fragment boolean on BooleanContent {
        value
      }

      fragment singleLine on SingleLineContent {
        text
      }

      fragment numeric on NumericContent {
        number
        unit
      }

      fragment contentChunk on ContentChunkContent {
        chunks {
          id
          name
          type
          content {
            ...content
          }
        }
      }
    `), {
        path,
        language: "no-nb",
    });
    if (!data.catalogue)
        throw new Error(`Catalogue item ${path} not found!`);
    if (data.catalogue?.__typename !== "Product")
        throw new Error(`Catalogue item ${path} is not a Product!`);
    return data.catalogue;
};
